import { TFunction } from "i18next";
import * as React from "react";
import {
    Actions,
    LimitsAndClosureStreamProps
} from "../../containers/LimitsAndClosureContainter/LimitsAndClosureContainer";
import LimitsAndClosureContextProvider from "../../context/LimitsAndClosureContext";
import LimitComponent from "../LimitComponent/LimitComponent";
import StatusBarInfoBox from "../StatusBarInfoBox/StatusBarInfoBox";

// tslint:disable-next-line:no-var-requires
const styles = require("./LimitsAndClosure.scss");

export interface LimitsAndClosureProps {
    activeScreen: string;
    navigation: (e: React.BaseSyntheticEvent) => void;
    t: TFunction;
}

export const LimitAndClosureScreens = {
    accountClosure: "AccountClosureScreen",
    exclusion: "ExclusionScreen",
    lossLimit: "LossLimitScreen",
    payInLimit: "PayInLimitScreen"
};

/* tslint:disable */
export const LimitsAndClosure = ({
    activeScreen,
    navigation,
    t,
    onUpdateLimitsAndClosure,
    ...externalData
}: LimitsAndClosureProps & LimitsAndClosureStreamProps & Actions) => {
    return (
        <>
            <div className={styles.breadcrumb}>
                <StatusBarInfoBox>{t("Title")}</StatusBarInfoBox>
            </div>
            <div className={styles.wrapper}>
                <LimitsAndClosureContextProvider
                    initialData={externalData}
                    updateHandler={onUpdateLimitsAndClosure}
                >
                    <LimitComponent
                        screen={activeScreen}
                        t={t}
                        navigationHandler={navigation}
                    />
                </LimitsAndClosureContextProvider>
            </div>
        </>
    );
};

export default LimitsAndClosure;
